/**
 * nordura-countdown.js
 * <countdown-timer> — days/hours/minutes countdown for the announcement bar.
 * If a merchant sets a fixed `data-end` (ISO date string, editable in the
 * Theme Editor), it counts down to that instant. Left blank, it falls back
 * to the original design's rolling "always ~2 days away" urgency timer,
 * which resets at midnight two days out so the bar never expires.
 */
(function () {
  'use strict';

  if (customElements.get('countdown-timer')) return;

  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.daysEl = this.querySelector('[data-n-countdown-days]');
      this.hoursEl = this.querySelector('[data-n-countdown-hours]');
      this.minutesEl = this.querySelector('[data-n-countdown-minutes]');
      this.endDate = this.parseEndDate(this.dataset.end);

      this.tick();
      this._interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    parseEndDate(raw) {
      if (raw) {
        var parsed = new Date(raw);
        if (!isNaN(parsed.getTime())) return parsed;
      }
      return null; // fall back to rolling countdown in tick()
    }

    tick() {
      var end = this.endDate;
      if (!end) {
        end = new Date();
        end.setHours(24, 0, 0, 0);
        end.setDate(end.getDate() + 2);
      }

      var totalSeconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var days = Math.floor(totalSeconds / 86400);
      totalSeconds -= days * 86400;
      var hours = Math.floor(totalSeconds / 3600);
      totalSeconds -= hours * 3600;
      var minutes = Math.floor(totalSeconds / 60);

      if (this.daysEl) this.daysEl.textContent = pad(days);
      if (this.hoursEl) this.hoursEl.textContent = pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
    }
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  customElements.define('countdown-timer', CountdownTimer);
})();
